const FREE_SUB_PLANS_IDS = [
  "00eyCRG1ZsldtyrrYYXL", // Freemium
  "01rpS24OcIIsDgSulxtW", // Trial
];

export { FREE_SUB_PLANS_IDS };
